import { render, staticRenderFns } from "./CollectionPlanEdit.vue?vue&type=template&id=0ab19e4c"
import script from "./CollectionPlanEdit.vue?vue&type=script&lang=js"
export * from "./CollectionPlanEdit.vue?vue&type=script&lang=js"
import style0 from "./CollectionPlanEdit.vue?vue&type=style&index=0&id=0ab19e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports